export default (state, data) => {
	console.info('🦑 SET_FULFILMENT_DATA', data);

	if (state.user.fulfilment === null) {
		state.user.fulfilment = {};
	}

	state.user.fulfilment = data;
};
